import React, {useEffect, useState} from "react";
import {SettingsContainer} from "../../pages/user/settings/styled";
import {ActionBar} from "../../pages/components/action-bar/action-bar";
import {Message, MessageSections} from "../../pages/components/message/message";
import {ManagementPageType} from "../user-order-management/management-data-container";
import {AdminToolPanel} from "../../pages/orders/my/tool-panel/admin-tool-panel";
import {OrderFilterModel} from "../../pages/shared/models/order/order-filter.model";
import {HistoryFilterModel} from "../../pages/shared/models/order/history-filter.model";
import historyService from "../../services/history.service";
import BarekamText from "../../pages/components/text";
import {OrderTable, OrderTableCell} from "../../pages/orders/my/order-list/styled";
import {TableBody, TableHead, TableRow} from "@mui/material";
import {HistoryTableColumn, HistoryTableColumnTypes} from "./history-table-column.model";
import {HistoryRow} from "./history-row";
import NoOrders from "../../pages/orders/my/no-orders";
import BarekamPagination from "../../pages/orders/my/pagination/barekam-pagination";
import {HistoryResponseModel} from "../../pages/shared/models/api/history-response.model";

const userColumn: HistoryTableColumn = {headerName: 'user', variant: HistoryTableColumnTypes.USER_NAME};
const operationColumn: HistoryTableColumn = {headerName: 'operation', variant: HistoryTableColumnTypes.OPERATION};
const collectionNameColumn: HistoryTableColumn = {headerName: 'collection_name', variant: HistoryTableColumnTypes.COLLECTION_NAME};
const updatedFieldsColumn: HistoryTableColumn = {headerName: 'updated_fields', variant: HistoryTableColumnTypes.UPDATED_FIELDS};
const dateColumn: HistoryTableColumn = {headerName: 'date', variant: HistoryTableColumnTypes.DATE};

const columns = [
    dateColumn,
    userColumn,
    operationColumn,
    collectionNameColumn,
    updatedFieldsColumn,
]

export const HistoryManagement = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [historyData, setHistoryData] = useState({
        currentPage: 0,
        audit: [],
        pageSize: 10,
        totalItems: 0,
    } as HistoryResponseModel);

    const [filter, setFilter] = useState<HistoryFilterModel | OrderFilterModel>({});

    useEffect(() => {
        loadHistory(0);
    }, [filter])

    function loadHistory(page: number) {
        setIsLoading(true);

        historyService.getFilteredHistory(filter, historyData.pageSize, page)
            .then(result => {
                setHistoryData(result)
                setIsLoading(false);
            })
    }

    function handlePageChange (event: unknown, newPage: number) {
        loadHistory(newPage - 1);
    }

    const HistoryTableHead = () => {
        return (
            <TableHead>
                <TableRow>
                    {columns.map((column, index) => (
                        <OrderTableCell key={`${index}-${column.variant}`}>
                            <BarekamText variant={'m'} fontWeight={600} align={'left'}>
                                <Message messageKey={column.headerName} sectionId={MessageSections.MAIN}/>
                            </BarekamText>
                        </OrderTableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    return (
        <SettingsContainer>
            <ActionBar headerText={<Message messageKey={'history'} sectionId={MessageSections.MAIN}/>}/>

            <AdminToolPanel filter={filter} setFilter={setFilter} type={ManagementPageType.HISTORY}/>

            {historyData.audit.length
                ? <OrderTable width={'100%'}>
                    <HistoryTableHead/>

                    <TableBody>
                        {historyData.audit.map((item, index) => {
                            if (item) {
                                return (
                                    <HistoryRow columns={columns} row={item} index={index}/>
                                )
                            } else {
                                return <></>
                            }
                        })}
                    </TableBody>
                </OrderTable>
                : isLoading ? '' : <NoOrders messageKey={'no_data'}/>
            }

            {historyData.totalItems > historyData.pageSize
                ? <BarekamPagination {...historyData} onPageChange={handlePageChange}/>
                : <></>
            }
        </SettingsContainer>
    )
}
